import { default as Link, default as link } from 'next/link'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

interface IItemProps {
    data: Record<string, any>
    isSelected: boolean
    onDropdownToggle: () => void
}

const Item: React.FC<IItemProps> = ({ data, isSelected, onDropdownToggle }) => {
    return (
        <li
            onClick={onDropdownToggle}
            className={`footer__production ${isSelected ? 'product__chapter_open' : 'product__chapter'}`}
        >
            <div
                onClick={onDropdownToggle}
                className='product__chapter-head'
            >
                <h3 className='footer__production-title product__chapter-title'>{data.title}</h3>
                <div className='product__chapter-state'>
                    <span
                        className={
                            isSelected
                                ? 'product__chapter-state-line product__chapter-state-line_minus'
                                : 'product__chapter-state-line'
                        }
                    ></span>
                    <span
                        className={
                            isSelected
                                ? 'product__chapter-state-line product__chapter-state-line_minus'
                                : 'product__chapter-state-line'
                        }
                    ></span>
                </div>
            </div>
            <div className={`footer__production-chapter ${isSelected ? 'product__chapter_open' : 'product__chapter'}`}>
                <div className='b2b__features-card-footer'>
                    <p className='main-about__card-text'>{data.text}</p>

                    <Link
                        href={data.link}
                        className='b2b__features-card-footer-link'
                    >
                        <p>{data.linkLabel}</p>

                        <div>
                            <svg
                                width='20'
                                height='20'
                                viewBox='0 0 20 20'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                            >
                                <path
                                    d='M9 15L12.9409 10.5664C12.9746 10.5285 12.9746 10.4715 12.9409 10.4336L9 6'
                                    stroke='#FEAA9F'
                                    strokeWidth='2'
                                    strokeLinecap='round'
                                />
                            </svg>
                        </div>
                    </Link>
                </div>
            </div>
        </li>
    )
}

interface IProps { }

export const B2BFeatures: React.FC<IProps> = () => {
    const [selectedChapters, setSelectedChapters] = useState<number[]>([])
    const {t} = useTranslation()
    const data = [
        {
            id: 1,
            title: t("MegamixGroup"),
            text: t("megamixGroupb2bCardText"),
            linkLabel: t("aboutCompany"),
            link: '/about-us'
        },
        {
            id: 2,
            title: t("HighQualityTitle"),
            text: t("HighQualityText"),
            linkLabel: t("catalog"),
            link: '/products'
        },
        {
            id: 3,
            title: t("EfficientLogisticsTitle"),
            text: t("EfficientLogisticsText"),
            linkLabel: t("export"),
            link: '/trading'
        },
        {
            id: 4,
            title: t("ContinuousRDTitle"),
            text: t("ContinuousRDText"),
            linkLabel: t("laboratories"),
            link: '/labs'
        },
        {
            id: 5,
            title: t("ExpertSupportTitle"),
            text: t("ExpertSupportText"),
            linkLabel: t("consulting"),
            link: '/consulting'
        },
        {
            id: 6,
            title: t("ReliabilityAndStabilityTitle"),
            text: t("ReliabilityAndStabilityText"),
            linkLabel: t("newsTitle"),
            link: '/news'
        },
        {
            id: 7,
            title: t("LargePortfolioTitle"),
            text: t("LargePortfolioText"),
            linkLabel: t("catalog"),
            link: '/catalog'
        }
    ]

    const handleBranchesDropdownToggle = (id: number) => () => {
        const isSelected = selectedChapters.includes(id)

        if (isSelected) {
            setSelectedChapters(prev => prev.filter(item => item !== id))
            return
        }
        setSelectedChapters(prev => [...prev, id])
    }

    return (
        <div style={{ display: 'flex', gap: 10 }} className='b2b__features'>
            <ul className='b2b__features-list'>
                {data.slice(0, 4).map(item => {
                    const isSelected = selectedChapters.includes(item.id)

                    return (
                        <Item
                            key={item.id}
                            data={item}
                            isSelected={isSelected}
                            onDropdownToggle={handleBranchesDropdownToggle(item.id)}
                        />
                    )
                })}
            </ul>
            <ul className='b2b__features-list'>
                {data.slice(4).map(item => {
                    const isSelected = selectedChapters.includes(item.id)

                    return (
                        <Item
                            key={item.id}
                            data={item}
                            isSelected={isSelected}
                            onDropdownToggle={handleBranchesDropdownToggle(item.id)}
                        />
                    )
                })}
            </ul>
        </div>
    )
}
